import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CustomCard from "./custom-card";

const useStyles = makeStyles({
    root: {
      marginBottom: '8px',
      margin:'32px',
      height: '100%',
      display: 'flex',
      boxShadow: 'none',
      padding: '40px'
    },
    parent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        padding: '35px'
    },
    rowParent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    button:{
      display: 'flex',
      flexDirection: 'row',
      marginTop:'30px'
    },
    primaryButton:{
      marginLeft: '25px'
    }
  });

  export default function AccessDenied({ notificationIcon, subtitle, cancelUrl,continueUrl }) {
    const classes = useStyles();
  
    return (
      <div css={`
        padding:35px;
        background:#F6F6FA;
        min-height:100vh;
      `}>
      <CustomCard className={classes.root}>
        <div className={classes.parent}>
            <div css={`
            svg {
              width:150px;
              height:150px;
              fill: #C4C4CD';
            }`}>
            {notificationIcon}
            </div>
            <div className={classes.rowParent}>
            {subtitle}
            </div>
            <div className={classes.button}>
              <div>
            <Button 
            variant="outlined" 
            size="large"
            onClick={() => {
                window.location.href = cancelUrl;
              }}
            >
             Close
            </Button>
            </div>
            <div className={classes.primaryButton}>
            <Button 
            variant="contained" 
            color="secondary"
            onClick={() => {
                window.location.href = continueUrl;
              }}
            >
               Continue
            </Button>
            </div>
            </div>
        </div>
      </CustomCard>
      </div>
    );
}